import { Outlet, createFileRoute } from '@tanstack/react-router';

import { ProductLogoMediumFleet as LogoFleet } from '@/components/Logo';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { useTranslation } from '@/lib/i18n';

export const Route = createFileRoute('/_staff/fleets/_layout')({
  component: Layout,
});

function Layout() {
  const { t } = useTranslation();
  useDocumentTitle(t('pages.fleets.title'));

  const tabs = [
    {
      to: '/fleets/overview',
      children: t('common.list.overview'),
      activeOptions: { exact: true },
    },
    {
      to: '/fleets',
      children: t('pages.fleets.listTab'),
      activeOptions: { exact: true },
    },
    { to: '/fleets/alerts', children: t('common.list.alerts') },
    {
      to: '/fleets/rule-and-policy',
      children: t('common.list.ruleAndPolicy'),
    },
    { to: '/fleets/settings', children: t('common.list.settings') },
  ] satisfies TabWithIndicatorProps[];

  return (
    <div className="flex flex-col">
      <ProductHeader
        Logo={LogoFleet}
        name={t('pages.fleets.title')}
        tabs={tabs}
        type="resource"
      />
      <Outlet />
    </div>
  );
}
